/**
 * The single live-region status line under the form buttons.
 * `role="status" aria-live="polite"` in the markup means every update
 * here is announced to screen readers.
 */

let statusEl: HTMLElement | null = null

function el(): HTMLElement {
  if (!statusEl) {
    statusEl = document.getElementById('status')
    if (!statusEl) throw new Error('#status element missing')
  }
  return statusEl
}

export function setStatus(message: string, isError = false): void {
  const status = el()
  status.textContent = message
  status.className = isError ? 'status error' : 'status'
}
